import { render } from "./EditRule.vue?vue&type=template&id=2a9b14b2&ts=true"
import script from "./EditRule.vue?vue&type=script&lang=ts"
export * from "./EditRule.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__